var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['switch',_vm.value?'open':'close'],on:{"click":_vm.onClick}},[_c('div',{staticClass:"dot"})])}
var staticRenderFns = []

export { render, staticRenderFns }